export default __webpack_public_path__ + "static/media/Products_Image_02.1edc4583.png";